// extracted by css-extract-rspack-plugin
export default {"dialogBody":"ExperimentsDialog-module__dialogBody__oF6tO","experimentsInput":"ExperimentsDialog-module__experimentsInput__xUmEP"};